module.exports = __webpack_public_path__ + "img/ai.387467d3.jpg";